import React, { useEffect, useState } from 'react'
import './HomeCategorias.scss'
import { DobleGuion } from '../components/DobleGuion'
import Separator from '../components/Separator'
import { getCategories, getProducts } from '../hooks/gets'
import { useNavigate, useLocation } from 'react-router-dom';
import { firstCharCapitalize } from '../utils/utils'
import { scrollBodyTop } from '../hooks/scrollPosition'
import { setAllProducts, setSelectedCategory, pushFilters, resetFilters, setPaginationState, setProductsTable, showSpinner } from '../actions'
import { connect } from 'react-redux'
import { CategoryFilter } from '../filters/CategoryFilter'
import * as _ from 'lodash'
import { selectCategoryExpositor, selectCategoryImplantations, selectCategoryOutlet } from '../hooks/selectCategory'
import { PopupOneButton } from './PopupOneButton'
import { BRANDCHOSEN, PreChangeBrandChosen } from '../hooks/config'

const HomeCategorias = (props) => {
    const { history, otherCategoriesAll } = props
    const navigate = useNavigate();

    const [categories, setCategories] = useState([])
    const [otherCategories, setOtherCategories] = useState([])
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)

    useEffect(() => {
        getCategories().then(res => {
            const menuOrder = res[BRANDCHOSEN].sort((a, b) => {
                return a.Position - b.Position;
            })
            setCategories(menuOrder)
        }).catch(err => {
            console.log('err', err);
        })
        console.log("otherCategoriesAll, category=",otherCategoriesAll);
        const otherCategoriesAux = _.filter(otherCategoriesAll, category => {
            return category.Name === 'Outlet' || category.Name === 'Expositores & PLV' || category.Name === 'Implantaciones'
        })
        setOtherCategories(_.sortBy(otherCategoriesAux, ['ID']))
    }, [])

    const changeBrandGlobal = (marca = 'fansa') => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(marca, props.budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const goToCategory = async (item) => {
        scrollBodyTop()
        let url = '';
        if (item.Name === 'Outlet') {
          changeBrandGlobal().then((res)=>{ //debug no es necesario si se muestran los productos de la marca elegida en la home
            if(res == true) {
              selectCategoryOutlet(props).then(res => {
                  url = '/outlet'
                  navigate(url)
              }).catch(err => {
                  console.log('err', err)
              })
            }
          })
        } else if (item.Name === 'Expositores & PLV') {
          changeBrandGlobal().then((res)=>{ //debug no es necesario si se muestran los productos de la marca elegida en la home
            if(res == true) {
              selectCategoryExpositor(props).then(res => {
                  url = '/expositores'
                  navigate(url)
              }).catch(err => {
                  console.log('err', err)
              })
            }
            })
        } else if (item.Name === 'Implantaciones') {
          changeBrandGlobal('scheurich').then((res)=>{ //debug no es necesario si se muestran los productos de la marca elegida en la home
            if(res == true) {
              selectCategoryImplantations(props).then(res => {
                  url = '/implantaciones'
                  navigate(url)
              }).catch(err => {
                  console.log('err', err)
              })
            }
            })
        } else {
            props.showSpinner(true)
            if (props.productsTable !== 'allProducts') {
                getProducts().then(res => {
                    console.log("goTocategory, getProducts,res=",res);
                    props.setAllProducts(res?.data)
                    configCategory(url, item)
                }).catch(err => {
                    props.showSpinner(false)
                })
            } else {
                configCategory(url, item)
            }

        }
    }

    const configCategory = async (url, item) => {
        props.setPaginationState(1)
        props.setProductsTable('allProducts')
        const categoryFilter = new CategoryFilter(item.Name)
        await props.setSelectedCategory({
            categoryId: item.ID,
            subtitle: item.Name,
            img: item.ImgBanner,
            selectedCollection: ''
        })
        props.resetFilters()
        props.pushFilters(categoryFilter)
        url = `/categoria/${item.ID}`
        navigate(url)
    }

    return (
        <div className="home-categorias">
          {showPopupPresupuestosPendientes &&
              <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
          }
            <div className="titulo"><DobleGuion /> <p>Categorías</p> <DobleGuion /></div>
            <div className="subtitulo">ENCUENTRA TU PRODUCTO</div>

            <div className="linea">
                {
                    categories.map((item, index) => {
                        return (
                            <div key={index} className="card">
                                <img src={item.ImgHome} onError={(e) => {
                                    e.target.onerror = null
                                    e.target.src = '/static/img/no-imagen-fansa.png'
                                }} alt="" />
                                <div className="card-section">
                                    <div className="card-section-title"><p>{firstCharCapitalize(item.Name)}</p></div>
                                    <div className="btn-container">
                                        <button className="btn" onClick={() => { goToCategory(item) }}><p>Ver más</p></button>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <Separator />

            {BRANDCHOSEN == 'fansa' && 
              <div className="other-secctions">
                  <div className="titulo"><p>Otras secciones</p><DobleGuion /></div>
                  <div className="cards">
                      {otherCategories.length > 0 && otherCategories.map((category, index) => {
                          return (
                              <div className="card" key={index}>
                                  <img src={category.ImgHome} onError={(e) => {
                                      e.target.onerror = null
                                      e.target.src = '/static/img/no-imagen-fansa.png'
                                  }} alt="" />
                                  <div className="card-section">
                                      <div className="card-section-title"><p>{category.Name}</p></div>
                                      <div className="btn-container">
                                          <button className="btn" onClick={() => { goToCategory(category) }}><p>Ver más</p></button>
                                      </div>
                                  </div>
                              </div>
                          )
                      })}
                  </div>
              </div>
            }
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setAllProducts,
    setSelectedCategory,
    pushFilters,
    setPaginationState,
    setProductsTable,
    resetFilters,
    showSpinner
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeCategorias);
